// A deal file waiting to upload, with the deal flow on (TX-US-0043): the file list's row, with
// what the file is asked for each file while it waits. The choice is remembered against the File
// (documentTypes.js), which is what its upload request reads.

import { useState } from 'react';

import PendingFile from '../counterparties/documents/PendingFile.jsx';
import { STATES } from '../deliveries/attachments/uploads.js';
import { rememberType, typeOf } from './documentTypes.js';
import DocumentTypeSelect from './DocumentTypeSelect.jsx';

export default function PendingTypedFile({ item, waiting, onRemove }) {
  const [type, setType] = useState(() => typeOf(item.file));

  const choose = (code) => {
    rememberType(item.file, code);
    setType(code);
  };

  return (
    <PendingFile item={item} waiting={waiting} onRemove={onRemove}>
      {item.state === STATES.queued && (
        <DocumentTypeSelect label={`Type of ${item.file.name}`} value={type}
                            onChange={choose} />
      )}
    </PendingFile>
  );
}
